import React from "react";
import "../styles/style.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ArmadaFormsProvider } from "../context/form-context";
import { useStaticQuery, graphql } from "gatsby";
import { SettingsAndSlugs } from "../models/settings-and-page-slugs.model";
import Helmet from "react-helmet";


const Layout: React.FC = ({ children }) => {
  // client test = https://drafbox-backend-dev.herokuapp.com/api/project/5ea1575f8c9344001f9a89ff/forms

  const data = useStaticQuery<SettingsAndSlugs>(graphql`
    query {
      draftboxSettings {
        identity {
          language
        }
      }
    }
  `);

  return (
    <ArmadaFormsProvider client={process.env.GATSBY_FORM_URL}>
      <Helmet
        htmlAttributes={{
          lang: data.draftboxSettings.identity.language
            ? data.draftboxSettings.identity.language
            : "auto",
        }}
      >
        <link rel="preconnect" href="https://ka-f.fontawesome.com" />
        <link rel="preconnect" href="https://storage.googleapis.com" />
        <script
          src="https://kit.fontawesome.com/9bc68fd9eb.js"
          defer={true}
          crossOrigin="anonymous"
        ></script>
      </Helmet>
      <div className="flex flex-col min-h-screen">
        <div>
          <Navbar />
          <hr />
        </div>
        <div className="flex-grow">{children}</div>
        <Footer />
      </div>
    </ArmadaFormsProvider>
  );
};

export default Layout;
